module.exports = __webpack_public_path__ + "img/ShaderEditorRayTracingComputeShader.0303e5fe.gif";